export default __webpack_public_path__ + "static/media/icon_youtube.9e9c2f5b.jpg";